import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput,
    Button,
    Checkbox,
    RadioButtonGroup,
    FormGroup,
    DatePickerInput,
    DatePicker,
    RadioButton,
    ComposedModal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    DropdownSkeleton,
    MultiSelect,
} from "carbon-components-react";
import moment from "moment";

import { ComboBox } from "../../helpers/ComboBox";
import { FindGHRSEmployer } from "../common/FindGHRSEmployer";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { DateFormat, entitiesLabels } from "../../helpers/Constants";
import DateTimePicker from "../../helpers/DateTimePicker";

import { api, dynamic } from '../../helpers/api/api';
import {
    getSuccess,
    getError,
    apioperation
} from '../../helpers/Constants';
import '../../scss/custom.scss';
import _sortBy from 'lodash/sortBy'; //RITM0946148
import SimpleReactValidator from 'simple-react-validator';



export class ModalTrainingCourse extends Component {
    initModalTrainingCourse = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            idTrainingData: null,  //string
            idLihsTrainingData: null,  //string
            idLanguage: null, //guid
            createdOn: null,
            info: null,
            lihsInfo: null,
            Language: null,
            actualTrainingName: null,//string
            certifiedDuration: null,
            certificateValidityMonths: null,
            validityDate: null, //date
            trainingMethodLists: [],
            trainingAssessmentMethodLists: [],
           // specifyOtherTrainingAssessmentMethod:null,
        }
    }

    constructor(props) {
        super(props);
        //this.validator = new SimpleReactValidator();
        this.state = {
            model: {
                ...this.initModalTrainingCourse(props)
            },
            mode: props.mode || 0,

        };
       
        this.gtzValidator = {
            message: 'The value must be greater than zero and less than equal to 10',
            rule: (val) => {
                return +val > 0 && +val <= 10;
            }
        };

        this.validator = new SimpleReactValidator({
            validators: { gtz: this.gtzValidator }
        });
        this.updateState = this.updateState.bind(this);
    }
    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({
            selectedItems: this.props.initialSelectedItems,
            loading: false,
        });
    }
    checkValidHours = (value) => {
        const hours = value ? +value : null
        const decimal = hours ? +hours.toString().split(".").splice(1).join() : 0

        if (!hours || (decimal !== 0 && decimal !== 5)) return false
        if (this.state.model.info != null && this.state.model.info.minDuration != null && value < this.state.model.info.minDuration) return false
        if (this.state.model.info != null && this.state.model.info.maxDuration != null && value > this.state.model.info.maxDuration) return false
        if (this.state.model.lihsInfo != null && this.state.model.lihsInfo.minDuration != null && value < this.state.model.lihsInfo.minDuration) return false
        if (this.state.model.lihsInfo != null && this.state.model.lihsInfo.maxDuration != null && value > this.state.model.lihsInfo.maxDuration) return false

        return true
    }
    save = () => {
        const validDuration = this.checkValidHours(this.state.model.certifiedDuration)
        const trainingStartDate = moment(this.props.startDate);
        const trainingEndDate = moment(this.props.endDate);
        const diffDuration = moment(this.props.endDate) >= moment(this.props.startDate)?trainingEndDate.diff(trainingStartDate, 'days')+1:0;
        const diffDurationInHours = diffDuration * 10;
        
        if (this.validator.allValid() && validDuration && (moment(this.props.endDate) >= moment(this.props.startDate)) && (this.state.model.certifiedDuration <= diffDurationInHours)) {
                this.props.save(this.state.model);
                showNotification.success(`${entitiesLabels.SUCCESS}`, "Course created successfully");
            
        } else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TRAINING + " required fields are missing  ");
            if (moment(this.props.endDate) < moment(this.props.startDate)) {
                this.setState({ invalidCertifiedDuration: true })
                showNotification.warning(`End Date Not Valid`, "The end date field must be after start date field")
            }
            if ((moment(this.props.endDate) >= moment(this.props.startDate)) && (this.state.model.certifiedDuration > diffDurationInHours)) {
                this.setState({ invalidCertifiedDuration: true })
                showNotification.warning(`Certified Duration Not Valid`, "Duration (hours) should not exceed 10 hours per day")
            }
           
            if (!validDuration) {
                this.setState({ invalidCertifiedDuration: true })
                showNotification.warning(`Certified Duration Not Valid`, "Duration (hours) should be between max duration & min duration or Only integer or decimal values ​​greater than 0 and with a scale of 0.5 are allowed")
            }
            this.forceUpdate();
        }
    }
    updateState = (inputName, inputValue, objName) => {
        const statusCopy = { ...this.state.model };
        if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
        else statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy });
    };
    handleChangeModel = (el) => {
        const inputName = el.target.name;
        const inputValue = el.target.value;
        const objName = el.target.alt;

        this.updateState(inputName, inputValue, objName);
    };
    handleChangeCertificateValidityPeriod = (e) => {
        const isEmptyOrWhiteSpace = (str) => {
            return str == null || str.match(/^ *$/) !== null;
        };
        const rawValue = e.target.value;
        const value = isEmptyOrWhiteSpace(rawValue) ? null : parseInt(rawValue);
        if (isNaN(value)) return;
        this.setState(prevState => {
            let modelCopy = { ...prevState.model };
            modelCopy.certificateValidityMonths = value;
            modelCopy.validityDate = value == null
                ? moment(this.state.model.validityDate).format("DD/MM/YYYY")
                : moment(modelCopy.endDate)
                    .add(value, 'year')
                    .format("YYYY-MM-DD");
            return {
                model: modelCopy
            };
        });
    };
    handleChangeCombo = (inputName, selectedItem, objName) => {
        let inputValue = selectedItem ? selectedItem.id : null;

        let statusCopy = Object.assign({}, this.state[objName]);
        statusCopy[inputName] = inputValue;

        if (inputName == "idTrainingData") {
            statusCopy.info = selectedItem;
            

        }
        if (inputName == "idLihsTrainingData") {
            statusCopy.lihsInfo = selectedItem;
           

        }
        if (inputName == "idLanguage") {
            statusCopy.language = selectedItem ? selectedItem.name : null;
        }

        this.setState({ [objName]: statusCopy });
    };
    onChangeTM = (selectedItem) => {
        const items = selectedItem ? selectedItem.selectedItems : null;
        const element = items?.map((elem) => ({ trainingMethod: elem, idTrainingMethod: elem.id })) || []
        this.updateStateTML("trainingMethodLists", element, "model", null)
    };

    updateStateTML = (inputName, inputValue, objName, parentObjName) => {
        let statusCopy = Object.assign({}, this.state);
        let oldOthers = {};
        let newOthers = {};
        let woNewOthers = [];
        if (inputName == 'trainingMethodLists') {
            newOthers = inputValue?.find(el => el?.trainingMethod?.name?.toLowerCase() === 'other (specify)') || {};
            woNewOthers = inputValue?.filter(el => el?.trainingMethod?.name?.toLowerCase() !== 'other (specify)') || inputValue;
            if (statusCopy[objName][inputName] !== undefined)
                oldOthers = statusCopy[objName][inputName].find(el => el.trainingMethod.name.toLowerCase() === 'other (specify)') || {};
            statusCopy[objName][inputName] = [...woNewOthers];
            if (Object.keys(oldOthers).length !== 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(oldOthers);
            else if (Object.keys(oldOthers).length === 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(newOthers);
        }


        this.setState({ statusCopy });
    }

    onChangeTAM = (selectedItem) => {
        const items = selectedItem ? selectedItem.selectedItems : null;
        const element = items?.map((elem) => ({ trainingAssessmentMethod: elem, idTrainingAssessmentMethod: elem.id })) || []
        this.updateStateTAML("trainingAssessmentMethodLists", element, "model", null)
    };

    updateStateTAML = (inputName, inputValue, objName, parentObjName) => {
        let statusCopy = Object.assign({}, this.state);
        let oldOthers = {};
        let newOthers = {};
        let woNewOthers = [];
        if (inputName == 'trainingAssessmentMethodLists') {
            newOthers = inputValue?.find(el => el?.trainingAssessmentMethod?.name?.toLowerCase() === 'other (specify)') || {};
            woNewOthers = inputValue?.filter(el => el?.trainingAssessmentMethod?.name?.toLowerCase() !== 'other (specify)') || inputValue;
            if (statusCopy[objName][inputName] !== undefined)
                oldOthers = statusCopy[objName][inputName].find(el => el.trainingAssessmentMethod.name.toLowerCase() === 'other (specify)') || {};
            statusCopy[objName][inputName] = [...woNewOthers];
            if (Object.keys(oldOthers).length !== 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(oldOthers);
            else if (Object.keys(oldOthers).length === 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(newOthers);
        }
        if (inputName == 'specifyOther') {
            oldOthers = statusCopy[objName][parentObjName].find(el => el.trainingAssessmentMethod.name.toLowerCase() === 'other (specify)') || {};
            if (Object.keys(oldOthers).length !== 0)
                oldOthers[inputName] = inputValue;
        }

        this.setState({ statusCopy });
    }
    handleSpecifyOtherTrainingAssessmentMethod = (el) => {
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateStateTAML("specifyOther", inputValue, objName, "trainingAssessmentMethodLists");
    };
    returnTrainingMethodLists = (id) => this.state.model.trainingMethodLists?.find(el => el.idTrainingMethod == id) ? true : false
    returnTrainingAssessmentMethodLists = (id) => this.state.model.trainingAssessmentMethodLists?.find(el => el.idTrainingAssessmentMethod == id) ? true : false
    returnValidTrainingData = (itemList) => {
        if (itemList) {
            return itemList.filter((el) => el.inUse);
        }
        return [];
    };
    render() {
        const appTrainingMethodList = (this.props.appTrainingMethodList || []).filter(
            (el) => (el.inUse) || this.state.model?.trainingMethodLists?.find(elem => elem?.idTrainingMethod == el.id));
        const appTrainingAssessmentMethodList = (this.props.appTrainingAssessmentMethodList || []).filter(
            (el) => (el.inUse) || this.state.model?.trainingAssessmentMethodLists?.find(elem => elem?.idTrainingAssessmentMethod == el.id));
        const selectedItemCombo = {

            idTrainingData: (this.props.appTrainingData || []).find(
                (el) => el.id == this.state.model.idTrainingData
            ),
            idLihsTrainingData: (this.props.appLihsTrainingData || []).find((el) => el.id == this.state.model.idLihsTrainingData),
            idLanguage: (this.props.appLanguage || []).find((el) => el.id == this.state.model.idLanguage),
            selectedTrainingMethodLists: (appTrainingMethodList || []).filter(
                (el) => this.returnTrainingMethodLists(el.id)),
            selectedTrainingAssessmentMethodLists: (appTrainingAssessmentMethodList || []).filter(
                (el) => this.returnTrainingAssessmentMethodLists(el.id)),

        };
        const showOtherTrainingAssessmentMethod = selectedItemCombo.selectedTrainingAssessmentMethodLists.find(el => el.name.toLowerCase() === 'other (specify)')?.specifyOther;
        const showActualTrainingName = (this.props.reportingType == "HSE") ? this.state.model.info != null && this.state.model.info.actualTrainingName == true
            : false;
        const showLihsActualTrainingName = (this.props.reportingType != "HSE") ? this.state.model.lihsinfo != null && this.state.model.lihsinfo.actualTrainingName == true:false;

        const validations = {
            certificateValidityMonths: this.validator.message("CertificateValidityPeriod", this.state.model.certificateValidityMonths, "required|gtz"),
            
            idTrainingData: this.props.reportingType == "HSE" ? this.validator.message("TrainingData", this.state.model.idTrainingData, "required") : null,
            idLihsTrainingData: this.props.reportingType != "HSE" ? this.validator.message("TrainingData", this.state.model.idLihsTrainingData, "required") : null,
            idLanguage: this.validator.message("Language", this.state.model.idLanguage, "required"),
            trainingMethodList: this.validator.message("Training Method", (this.state.model?.trainingMethodLists || [])[0], "required"),
            trainingAssessmentMethodList: this.validator.message("Training Assessment Method", (this.state.model?.trainingAssessmentMethodLists || [])[0], "required"),

            certifiedDuration: this.validator.message("Certified Duration", this.state.model.certifiedDuration, "required"),
            actualTrainingName: this.validator.message("Actual Training Name", (showActualTrainingName == true || showLihsActualTrainingName == true) && (this.state.model.actualTrainingName), "required") ,
            
            specifyOtherAssessmentMethod: this.validator.message("Training assessment method Specify Other ", showOtherTrainingAssessmentMethod == true && (this.state.model?.trainingAssessmentMethodLists || []).find(el => el?.trainingAssessmentMethod?.name?.toLowerCase() == 'other (specify)')?.specifyOther, "required"),
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;

        return (
            <ComposedModal
                className="light-modal-max-height"
                open={isOpenModal}
                danger="false"
                onClose={() => { return false; }}
            >
                <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                <ModalBody>
                    <div className="bx--grid--full-width">
                        <div className="bx--row">
                            <div className="bx--col-lg-6 bx--col-md-4">
                                {this.props.reportingType == "HSE" && (
                                    <FormGroup legendText="Training Title And Code*">
                                        {this.props.appTrainingData == null ? (
                                            <DropdownSkeleton />
                                        ) : (
                                            <ComboBox
                                                id="idTrainingData"
                                                placeholder="Select"
                                                name="idTrainingData"
                                                alt="model"
                                                onChange={this.handleChangeCombo}
                                                itemToString={(item) => (item ? item.courseCode : "")}
                                                initialSelectedItem={selectedItemCombo.idTrainingData}
                                              //  items={this.props.appTrainingData}
                                                    items={this.returnValidTrainingData(this.props.appTrainingData) ?? []}
                                                    disabled={this.props.appTrainingData.length === 0}
                                                    shouldFilterItem={({ item, inputValue }) =>
                                                        item.courseCode.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                        item.courseCode.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                            />
                                        )

                                        }
                                        {validations.idTrainingData}
                                    </FormGroup>
                                )}
                                {this.props.reportingType != "HSE" && (
                                    <FormGroup legendText="Training Title And Code*">
                                        {this.props.appLihsTrainingData == null ? (
                                            <DropdownSkeleton />
                                        ) : (
                                            <ComboBox
                                                id="idLihsTrainingData"
                                                placeholder="Select"
                                                name="idLihsTrainingData"
                                                alt="model"
                                                onChange={this.handleChangeCombo}
                                                itemToString={(item) => (item ? item.courseCode : "")}
                                                initialSelectedItem={selectedItemCombo.idLihsTrainingData}
                                                   // items={this.props.appLihsTrainingData}
                                                    items={this.returnValidTrainingData(this.props.appLihsTrainingData) ?? []}
                                                    shouldFilterItem={({ item, inputValue }) =>
                                                        item.courseCode.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                        item.courseCode.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                disabled={this.props.appLihsTrainingData.length === 0}
                                            />
                                        )

                                        }
                                        {validations.idLihsTrainingData}
                                    </FormGroup>
                                )}
                            </div>
                            <div className="bx--col-lg-6 bx--col-md-4">
                                <FormGroup legendText="Training Delivery Language*">
                                    <ComboBox
                                        id="idLanguage"
                                        key={`idLanguage${this.state.model.idLanguage}`}
                                        placeholder="Select"
                                        name="idLanguage"
                                        alt="model"
                                        onChange={this.handleChangeCombo}
                                        itemToString={(item) => (item ? item.name : "")}
                                        initialSelectedItem={selectedItemCombo.idLanguage}
                                        items={this.props.appLanguage}
                                        shouldFilterItem={({ item, inputValue }) =>
                                            item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                            item.code.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        disabled={this.props.appLanguage == null}

                                    />
                                    {validations.idLanguage}
                                </FormGroup>
                            </div>
                        </div>

                        <div className="bx--row">
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup legendText="Min Duration (hours)">
                                    <TextInput
                                        id="minDuration"
                                        value={(this.state.model.info && this.state.model.info.minDuration) || (this.state.model.lihsInfo && this.state.model.lihsInfo.minDuration)}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        disabled={true}
                                        className="bx--text-input disable-text"
                                    />
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup legendText="Max Duration (hours)*">
                                    <TextInput
                                        id="maxDuration"
                                        value={(this.state.model.info && this.state.model.info.maxDuration) || (this.state.model.lihsInfo && this.state.model.lihsInfo.maxDuration)}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        disabled={true}
                                        className="bx--text-input disable-text"

                                    />
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup legendText="Duration (hours)*">
                                    <TextInput
                                        id="certifiedDuration"
                                        name="certifiedDuration"
                                        value={(this.state.model && this.state.model.certifiedDuration) || ""}
                                        labelText=""
                                        // disabled={(this.state.model.info != null && this.state.model.info.duration > 0) || this.state.isDisabled}
                                        alt="model"
                                        onChange={this.handleChangeModel}
                                        type="number"
                                        hideLabel={true}
                                        invalid={validations.certifiedDuration != null || this.state.invalidCertifiedDuration}
                                    />
                                </FormGroup>
                            </div>

                           
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup legendText="MyP Code">
                                    <TextInput
                                        id="PeopleLearningCode"
                                        value={(this.state.model.info && this.state.model.info.peopleLearnigCode) || (this.state.model.lihsInfo && this.state.model.lihsInfo.peopleLearnigCode)}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        disabled={true}
                                        className="bx--text-input disable-text"
                                    />
                                </FormGroup>
                            </div>
                        </div>
                        <div className="bx--row">
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup key="validityDate" legendText="Certificate Validity Period (Years) *">
                                    <TextInput
                                        className="cell--item"
                                        name="certificateValidityMonths"
                                        alt="model"
                                        value={this.state.model.certificateValidityMonths}
                                        onChange={this.handleChangeCertificateValidityPeriod}
                                        type="number"
                                        min="1"
                                        max="10"
                                        invalid={validations.certificateValidityMonths != null}
                                        
                                    />
                                    {validations.certificateValidityMonths}
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-3 bx--col-md-4">
                                <FormGroup key="validityDate" legendText="Certificate Validity Date">
                                    <DatePicker
                                        datePickerType="simple"
                                        className="disable-text"
                                    >
                                        <DatePickerInput
                                            id="certificate-validity-date-input"
                                            placeholder=""
                                            disabled
                                            value={
                                                this.state.model.validityDate
                                                    ? moment(this.state.model.validityDate).format('DD/MM/YYYY')
                                                    : ''
                                            }
                                        />
                                    </DatePicker>
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-6 bx--col-md-4">
                                {(showActualTrainingName || showLihsActualTrainingName) && (
                                    <FormGroup legendText="Actual Training Name*">

                                        <TextInput
                                            id="actualTrainingName"
                                            name="actualTrainingName"
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            onChange={this.handleChangeModel}
                                            alt="model"
                                            value={(this.state.model && this.state.model.actualTrainingName) || ""}
                                        />
                                        {validations.actualTrainingName}
                                    </FormGroup>
                                )}
                            </div>

                        </div>
                       
                        <div className="bx--row">
                            <div className="bx--col-lg-6">
                                <FormGroup legendText="Training Delivery Methods*">
                                    {this.props.appTrainingMethodList == null ? (
                                        <DropdownSkeleton />
                                    ) : (
                                        <MultiSelect.Filterable
                                            direction={this.props.openUp ? "top" : "bottom"}
                                            id="guidTrainingMethodList"
                                            invalid={validations.trainingMethodList != null}
                                            invalidText={validations.trainingMethodList}
                                            placeholder={
                                                this.state.model.trainingMethodLists?.length < 1 || this.state.model.trainingMethodLists == null
                                                    ? "Choose one or more items"
                                                    : selectedItemCombo.selectedTrainingMethodLists?.map((elem) => elem.name).join(', ')
                                            }
                                            itemToString={(item) => (item ? item.name : "")}
                                            items={this.props.appTrainingMethodList}
                                            onChange={this.onChangeTM}
                                            type="default"
                                            initialSelectedItems={selectedItemCombo.selectedTrainingMethodLists}
                                            disabled={this.state.isDisabled}
                                            sortItems={(items) => items}
                                        />
                                    )}
                                    {/* {validations.trainingMethodList}*/}
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-6">
                                <FormGroup legendText="Training Assessment Methods*">
                                    {this.props.appTrainingAssessmentMethodList == null ? (
                                        <DropdownSkeleton />
                                    ) : (
                                        <MultiSelect.Filterable
                                            direction={this.props.openUp ? "top" : "bottom"}
                                            id="guidTrainingAssessmentMethodList"
                                            invalid={validations.trainingAssessmentMethodList != null}
                                            invalidText={validations.trainingAssessmentMethodList}
                                            placeholder={
                                                this.state.model.trainingAssessmentMethodLists?.length < 1 || this.state.model.trainingAssessmentMethodLists == null
                                                    ? "Choose one or more items"
                                                    : selectedItemCombo.selectedTrainingAssessmentMethodLists?.map((elem) => elem.name).join(', ')
                                            }
                                            itemToString={(item) => (item ? item.name : "")}
                                            items={this.props.appTrainingAssessmentMethodList}
                                            onChange={this.onChangeTAM}
                                            type="default"
                                            initialSelectedItems={selectedItemCombo.selectedTrainingAssessmentMethodLists}
                                            disabled={this.state.isDisabled}
                                            sortItems={(items) => items}
                                        />
                                    )}
                                    {/* {validations.trainingAssessmentMethodList}*/}
                                </FormGroup>
                            </div>
                        </div>
                        <div className="bx--row">
                            <div className="bx--col-lg-6">
                                {showOtherTrainingAssessmentMethod && (
                                    <div className="bx--col-lg-6">
                                        <FormGroup legendText="Specify other*">
                                            
                                            <TextInput
                                                id="specifyOtherTrainingAssessmentMethod"
                                                name="specifyOtherTrainingAssessmentMethod"
                                                alt="model"
                                                value={this.state.model && this.state.model.trainingAssessmentMethodLists?.find(e1 => e1?.trainingAssessmentMethod?.name?.toLowerCase() === 'other (specify)')?.specifyOther || ''}
                                                type="text"
                                                hideLabel="true"
                                                disabled={this.state.isDisabled}
                                                onChange={this.handleSpecifyOtherTrainingAssessmentMethod}
                                                                                          
                                            />
                                             {validations.specifyOtherAssessmentMethod}
                                        </FormGroup>
                                    </div>

                                )}
                            </div>
                            <div className="bx--col-lg-6">

                            </div>
                        </div>
                        
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                    <Button kind='primary' onClick={() => this.save()}>Save</Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
}

ModalTrainingCourse.propTypes = {
    save: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isEditModal: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    title: PropTypes.string,

};

// aggiunto
ModalTrainingCourse.defaultProps = {
    openUp: false,
    invalid: false,
    disabled: false,
    initialSelectedItems: [],
};
export default ModalTrainingCourse;